import React from 'react';
import { NavLink } from 'react-router-dom';
// import '../../styles/footer.css';
const Footer = () => {
  return (
    <footer className="footer">
		<div className="container-fluid">
			<div className="row text-muted">
				<div className="col-6 text-start">
					<p className="mb-0">
						<NavLink to="https://sample.com/" target="_blank" className="text-muted"><strong>Admin Dashboard</strong></NavLink> &copy;
					</p>
				</div>
				<div className="col-6 text-end">
					<ul className="list-inline">
						<li className="list-inline-item">
							<NavLink className="text-muted" to="#">Support</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-muted" to="#">Help Center</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-muted" to="#">Privacy</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-muted" to="#">Terms</NavLink>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
  );
};

export default Footer;